<template>
	<div class="o-embed__content">
		<div class="o-embed__message" v-show="!hasCookieConsent && showConsentUi">
			<div class="o-embed__message-content" v-show="cookiebotLoaded">
				<p>This content is blocked</p>
				<p>Please enable cookies to view</p>

				<button
					class="o-button"
					@click="acceptRequiredCategories()"
				>
					{{ requiredCategoryString() }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	import CookieConsent from "../mixins/cookie-consent.vue";

	export default {
		name: "embed",
		mixins: [CookieConsent],
		data() {
			return {
				rendered: false,
			};
		},
		props: {
			embedCode: {
				Type: String,
			},
		},
		watch: {
			hasCookieConsent: function () {
				if (!this.hasCookieConsent) {
					return;
				}

				this.renderEmbed();
			},
		},
		methods: {
			renderEmbed() {
				console.log(this.rendered);
				if (this.rendered) {
					return;
				}

				this.$el.innerHTML = this.stripScripts(this.embedCode);

				let parser = new DOMParser();
				let embedCode = JSON.parse(this.embedCode);
				let parsedHTML = parser.parseFromString(embedCode, "text/html");

				// Get all scripts from parsed embedCode and append them to the component.
				let embedScripts = parsedHTML.getElementsByTagName("script");

				for (let i = 0; i < embedScripts.length; i++) {
					let scriptElement = document.createElement("script");
					let script = embedScripts[i];
					let scriptAttrs = script.attributes;

					for (let j = 0; j < scriptAttrs.length; j++) {
						let name = scriptAttrs[j].name;
						let value = scriptAttrs[j].value;

						scriptElement.setAttribute(name, value);
					}

					if (script.src.length) {
						scriptElement.src = script.src;
					}

					if (script.innerHTML.length) {
						scriptElement.innerHTML = script.innerHTML;
					}

					this.$el.appendChild(scriptElement);

					this.rendered = true;
				}
			},

			/**
			 * Removes script tags from the given string.
			 *
			 * @returns {string}
			 */
			stripScripts(value) {
				let embedCode = JSON.parse(value);
				let scriptRegex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;

				return embedCode.replace(scriptRegex, "");
			},
		},
	};
</script>
